<div class="closeIconContainer">
    <i [mat-dialog-close]="true" class="fa fa-times closeIcon" aria-hidden="true"></i>
</div>

<div class="main">
    <div style="display: flex; justify-content:center; align-items:center">
        <div style="font-size: 20px; font-weight: 600;">Terms and conditions</div>
    </div>

    <div style="margin-top: 20px;">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eos iure ipsa ducimus,
        optio illo culpa, eaque animi, odit unde reiciendis ipsum. Itaque, modi? Dicta voluptatibus error officia
        praesentium suscipit quidem.</div>
</div>